import Type4FlightCard from "./Type4FlightCard";
import {
    PlaneTakeoff
} from "lucide-react";

const Type4FlightDetailsSection = ( props ) => {

    const {
        itinerary,
        pageTheme,
    } = props;

    const {
      packageTrendsPageType,
      packageTrendsPageBackground,
      packageTrendsPageCardBackground,
      packageTrendsPagePrimaryColor,
      packageTrendsPageSecondColor,
      packageTrendsPageThirdColor,
      packageTrendsPageFourthColor,
    } = pageTheme;

    return <div style={{marginTop: 20, marginBottom: 30}}>
        <h2 style={{color: (packageTrendsPageThirdColor+"E6"), marginTop: 40}} className="text-2xl font-black text-slate-900 mb-8 flex items-center gap-3">
            <PlaneTakeoff style={{color: packageTrendsPagePrimaryColor}} size={24} className="text-indigo-600" />
            <span dangerouslySetInnerHTML={{ __html: (itinerary?.designer_plus_labels?.flight_section_title || "Flight Schedules") }}></span>
        </h2>
        {
            itinerary?.included_flights?.map(each=>{
                return <Type4FlightCard
                    offer={each}
                    pageTheme={pageTheme}
                />
            })
        }
        
    </div>
}

export default Type4FlightDetailsSection;
